/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AITool
 */
export interface AITool {
    /**
     * 
     * @type {string}
     * @memberof AITool
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AITool
     */
    description: string;
}

/**
 * Check if a given object implements the AITool interface.
 */
export function instanceOfAITool(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "description" in value;

    return isInstance;
}

export function AIToolFromJSON(json: any): AITool {
    return AIToolFromJSONTyped(json, false);
}

export function AIToolFromJSONTyped(json: any, ignoreDiscriminator: boolean): AITool {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'description': json['description'],
    };
}

export function AIToolToJSON(value?: AITool | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'description': value.description,
    };
}

